import { useState, useEffect } from "react";
import { axiosWithoutHeader, axiosReset, axiosQuick } from "../api/axios";
import { Link, useSearchParams } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment, IconButton, TextField, Grid } from "@mui/material";
const RESET_PASSWORD = "/forgotPassword";
const CHECK_EMAIL_RESET_PASSWORD = "/check-forgotPassword-email";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [eyeSlashPassword, seteyeSlashPassword] = useState(false);
  const [eyeSlashConfirmPassword, seteyeSlashConfirmPassword] = useState(false);
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const [confirmPasswordError, setconfirmPasswordError] = useState("")
  const [passwordError, setpasswordError] = useState("")
  const [status, setStatus] = useState("");
  const [token, setToken] = useState("");
  const [searchParams] = useSearchParams();
  const [isSuperAdmin, setisSuperAdmin] = useState(false)
  let userKey;
  for (const entry of searchParams.entries()) {
    userKey = entry[1];
  }
  const getData = async () => {
    try{
      const response = await axiosWithoutHeader.get(CHECK_EMAIL_RESET_PASSWORD, {
        params: {
          userKey: userKey,
        },
      });
      console.log("response",response)
      if( response && response?.data?.status==200){
        setEmail(response?.data?.email);
        setKey(response?.data?.userKey);
        setToken(response?.data?.token);
        setisSuperAdmin(response.data.isSuperAdmin)
    
        localStorage.setItem("resetToken", response?.data?.token);
      }
      else{
        setError(response?.data?.error);
      }
    }
    catch(err){
console.log('err',err)
setError(err.data?.error);
    }
    }
  
  useEffect(() => {
    getData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!password){
      setpasswordError("Password is required");
      
    } 
    else if (password !== confirmPassword) {
      setconfirmPasswordError("Password and confirm password are not same");
      setpasswordError("")
    }
    else  {
      setconfirmPasswordError("");
      setpasswordError("")
      try {
        const response = await axiosQuick.post(
          RESET_PASSWORD,
          {
            email: email,
            userKey: key,
            password: password,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.status === 404) {
          setError("This password reset token is invalid.");
        } else if (response.status === 200) {
          setisSuperAdmin(response.data.isSuperAdmin)
          setStatus(
            "Congratulations, Your password has been succesfully reset."
          );
        }
      } catch (err) {
        if (err?.response === 500) {
          setError("bad Server Response");
        } else if (err.response?.status === 404) {
          setError("user not found");
        } else if (err.response?.status === 401) {
          setError("you are Unauthorized");
        } else {
        }
      }
    }
  };
  return (
    <section className="shadow login-container">
      <div className="row align-items-center h-100 no-gutters">
        <div className="col-12 col-sm-7 p-3  align-items-center h-100 rounded">
          {status ? (
            <div className="signup-sucess">
              <h4 className="text-center">{status}</h4>
              <p>
                <Link to={isSuperAdmin?"/admin":"/consultant"} className="btn btn-primary w-100">
              
                  Login Now
                </Link>
              </p>
            </div>
          ) : (
            <div className="input-body">
              <div
                className={error ? "alert alert-danger" : "offscreen"}
                aria-live="assertive"
              >
                {error}
              </div>
              <p className="loginTxt">
                Back to <Link to={isSuperAdmin?"/admin":"/consultant"}>Sign in</Link>
              </p>
              <div className="text-align-center">
                <h5>
                Please enter your new Password here for future reference.
                </h5>
              </div>
              <form onSubmit={handleSubmit}>
              <Grid container spacing={8} marginTop={"16px"}>
                <Grid  item xs={12}>
                <TextField
                      type={eyeSlashPassword ? "text" : "password"}
                      fullWidth
                      autoComplete="off"
                      label="New Password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      
                      error={Boolean(passwordError)}
                      helperText={passwordError}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => seteyeSlashPassword(!eyeSlashPassword)}
                              edge="end"
                            >
                              {eyeSlashPassword ?  <Visibility />: <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                </Grid>
                
                   
                  <Grid  item xs={12}>
                  <TextField
                      type={eyeSlashConfirmPassword ? "text" : "password"}
                     fullWidth
                      autoComplete="off"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      value={confirmPassword}
                      label="Confirm New Password"
                      error={Boolean(confirmPasswordError)}
                      helperText={confirmPasswordError}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => seteyeSlashConfirmPassword(!eyeSlashConfirmPassword)}
                              edge="end"
                            >
                              {eyeSlashConfirmPassword ?  <Visibility />: <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
             
               
                  <Grid  item xs={12}>
                  <button
                  type="submit"
                  className="btn btn-primary btn-primary w-100"
                >
                  Reset Password
                </button>
                  </Grid>
                 
                 </Grid>
              
              </form>
            </div>
          )}
        </div>
        <div className="col-12 col-sm-5 text-white content-body mt-0 h-100 align-items-center d-flex rounded">
          <div className="position-relative">
            <span>
              <i className="fa-solid fa-quote-left" />
            </span>
            <img
              src="logo.png"
              style={{ width: "100%", marginLeft: "-25px" }}
            ></img>
            <small className="d-flex align-items-start position-relative px-5 pt-5 pb-4">
              "We are a team of professionals comprising of experienced
              chartered accountants, advocates, lawyers and company
              secretaries."
            </small>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ResetPassword;
